module.exports = __webpack_public_path__ + "img/user.cf3627db.png";